import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useGeo } from '../context/GeoContext';

// Маппинг стран на языки
const countryToLanguage = {
    'RU': 'ru',
    'BY': 'be',
    'KZ': 'kz',
    'AM': 'am',
    'AZ': 'az',
    'UA': 'ua',
    'TR': 'tr',
    'BR': 'pt',
    'PT': 'pt',
    'US': 'en',
    'GB': 'en',
    'AU': 'en',
    'CA': 'en',
    'NZ': 'en',
    'IE': 'en',
    'ZA': 'en'
    // Для остальных стран будет английский по умолчанию
};

export const useLanguageDetection = () => {
    const { i18n } = useTranslation();
    const { isAuth, isLoading: authLoading } = useAuth();
    const { userCountry, isGeoChecking } = useGeo();

    useEffect(() => {
        // Ждем завершения проверки авторизации и геолокации
        if (authLoading || isGeoChecking) {
            return;
        }

        // Для авторизованных пользователей используем сохраненный язык или русский
        if (isAuth) {
            let savedLang = 'ru';
            try {
                if (typeof localStorage !== "undefined" && localStorage) {
                    savedLang = localStorage.getItem("language") || 'ru';
                }
            } catch (e) {
                savedLang = 'ru';
            }

            console.log(`👤 Авторизованный пользователь: используем язык=${savedLang}`);

            if (i18n.language !== savedLang) {
                i18n.changeLanguage(savedLang);
            }
            return;
        }

        // Для неавторизованных пользователей определяем язык по геолокации
        let detectedLang = 'en'; // Английский по умолчанию

        if (userCountry) {
            detectedLang = countryToLanguage[userCountry] || 'en';
        }

        console.log(`🌍 Автоопределение языка: страна=${userCountry}, язык=${detectedLang}`);

        // Проверяем, есть ли вручную выбранный язык
        let manualLang = null;
        try {
            if (typeof localStorage !== "undefined" && localStorage) {
                manualLang = localStorage.getItem("language");
            }
        } catch (e) {
            // ignore
        }

        // Если пользователь вручную выбрал язык, используем его
        if (manualLang) {
            console.log(`🎯 Неавторизованный пользователь выбрал язык вручную: ${manualLang}`);
            if (i18n.language !== manualLang) {
                i18n.changeLanguage(manualLang);
            }
            return;
        }

        // Изменяем язык только если он отличается от текущего
        if (i18n.language !== detectedLang) {
            i18n.changeLanguage(detectedLang);
        }

    }, [isAuth, authLoading, userCountry, isGeoChecking, i18n]);
}; 